export default __webpack_public_path__ + "static/media/remove-from-cart.4c2dafa4.png";